import { render, staticRenderFns } from "./SubstepTextCard.vue?vue&type=template&id=61ce5a02"
import script from "./SubstepTextCard.vue?vue&type=script&lang=js"
export * from "./SubstepTextCard.vue?vue&type=script&lang=js"
import style0 from "./SubstepTextCard.vue?vue&type=style&index=0&id=61ce5a02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports